import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
let _userState = {
    userSignedIn: false,
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _subscribers = new Set();
const _subscribe = (cb) => {
    _subscribers.add(cb);
    return () => {
        _subscribers.delete(cb);
    };
};
const publish = (nextUserState) => {
    _userState = nextUserState;
    _subscribers.forEach((cb) => cb(nextUserState));
};
const useUserState = () => {
    const [user, setState] = useState(Object.assign(Object.assign({}, _userState), { userSignedIn: !!Cookies.get('ursid') }));
    useEffect(() => {
        return _subscribe(setState);
    }, []);
    return [user, publish];
};
export { useUserState };
